import React from 'react';
import { ReactComponent as RenativeLogoMini } from 'assets/CarBrand/brand_renative_mini.svg'; //NOSONAR
import { tireBrandsData, TireBrandType } from 'pages/TiresPage/TireSearch/TiresSearchbar/TireBrandsData';
import { Icon, Image } from 'UI';

// brand_renative_mini.svg natural dimensions: 50x20 → aspect ratio 2.5:1
const RENATIVE_MINI_WIDTH = 50;
const RENATIVE_MINI_HEIGHT = 20;
const RENATIVE_MINI_ASPECT_RATIO = RENATIVE_MINI_WIDTH / RENATIVE_MINI_HEIGHT;

export const TireBrandImage = ({
  referenceBrandId,
  width = 100,
  height = 30,
  renative,
}: {
  referenceBrandId?: string;
  width?: number;
  height?: number;
  renative?: boolean;
}) => {
  if (renative) {
    const naturalWidth = Math.round(height * RENATIVE_MINI_ASPECT_RATIO);
    return <Icon IconComponent={RenativeLogoMini} width={naturalWidth} height={height} noPointer />;
  }

  const getIcon = () => {
    const brandData = tireBrandsData.find((b) => b.brandId === referenceBrandId);
    const undefinedBrand = { brandId: '', image: '', name: '', selected: false } as TireBrandType;
    const brandDataF = brandData ?? undefinedBrand;
    return brandDataF.image;
  };
  return <Image src={getIcon()} alt={'brand_image'} height={height} maxWidth={width} />;
};
